import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators'

import { Question } from '../shared/question'
import { Response } from '../shared/response';
import { SurveyService } from '../services/surveyService';
import { QuestionsService } from '../services/questionsService'
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit, OnDestroy {
  constructor(private questionService: QuestionsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private surveyService: SurveyService) { }


  ngOnInit(): void {
    this.sub = this.activatedRoute.params.subscribe((params: any) => {
      this.surveyId = params.surveyId;
    });

    this.sub = this.activatedRoute.queryParams.subscribe((params: any) => {
      this.period = params.period;
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const clickedQuestionId = (event.target as HTMLElement).closest('app-question')?.getAttribute('id');
    if (clickedQuestionId) {
      document.querySelector(`.box.box-${clickedQuestionId}`)?.classList.add('focused');
    }
  }

  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent) {
  //   const isClickInsideAppQuestion = (event.target as HTMLElement).closest('app-question');
  //   // Check if the click was outside of the app-question component
  //   if (isClickInsideAppQuestion) {
  //     const allQuestionsList = this.renderQuestions();

  //     // Loop through all questions to check for responses
  //     allQuestionsList.forEach(question => {
  //       if (question.responses.filter(q => q.selected).length > 0) {
  //         const questionId = question.id;
  //         const selector = `.box.box-${questionId}`; // Select the specific question box
  //         const element = document.querySelector(selector);

  //         if (element) {
  //           element.classList.remove('focused'); // Remove the 'focused' class
  //         }

  //         // Disable all input and textarea elements within the app-question component
  //         const inputs = document.querySelectorAll(`.box.box-${questionId} input`);
  //         const textareas = document.querySelectorAll(`.box.box-${questionId} textarea`);

  //         //@ts-ignore
  //         inputs.forEach(input => input.disabled = true); // Disable each input
  //         //@ts-ignore
  //         textareas.forEach(textarea => textarea.disabled = true); // Disable each textarea
  //       }
  //     });
  //   }
  // }



  // Variabilă pentru a păstra întrebarea curentă
  currentQuestionId: number | null = null;
  hasAlreadyBeenClicked: boolean = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const isClickInsideAppQuestion = (event.target as HTMLElement).closest('app-question');

    if (isClickInsideAppQuestion) {
      const clickedAppQuestionElement = isClickInsideAppQuestion as HTMLElement;

      // Extrage ID-ul întrebării curente din clasa `box-${question.id}`
      const questionIdMatch = clickedAppQuestionElement.classList.toString().match(/box-(\d+)/);

      if (questionIdMatch && questionIdMatch[1]) {
        const clickedQuestionId = Number(questionIdMatch[1]);

        // Verifică dacă utilizatorul a trecut la o întrebare diferită
        if (this.currentQuestionId != null && this.currentQuestionId !== clickedQuestionId) {
          // Obține lista de întrebări
          const allQuestionsList = this.renderQuestions();

          // Găsește întrebarea anterioară și dezactivează input-urile și textarea-urile sale
          const previousQuestion = allQuestionsList.find(question => question.id === this.currentQuestionId && !question.lockDisabled);
          if (previousQuestion && previousQuestion.responses.filter(q => q.selected).length > 0) {
            const previousQuestionSelector = `.box.box-${this.currentQuestionId}`;
            const previousElement = document.querySelector(previousQuestionSelector);

            if (previousElement) {
              previousElement.classList.remove('focused');
            }

            // Dezactivează input-urile și textarea-urile întrebării anterioare
            const previousInputs = document.querySelectorAll(`${previousQuestionSelector} input`);
            const previousTextareas = document.querySelectorAll(`${previousQuestionSelector} textarea`);

            //@ts-ignore
            previousInputs.forEach(input => input.disabled = true);
            //@ts-ignore
            previousTextareas.forEach(textarea => textarea.disabled = true);
          }
        }

        // Actualizează întrebarea curentă cu cea pe care s-a făcut click
        this.currentQuestionId = clickedQuestionId;
      }
    }
  }



  sub!: any;
  surveyId!: string;
  period!: string;
  questions = this.questionService.getQuestions();
  surveyType = this.questionService.getSurveyType();

  validateForm(form: FormGroup): boolean {
    let values = form.value;
    // console.log(this.questions)

    let valid = true;

    Object.keys(values).forEach(group => {
      let questionId = parseInt(group.split('_')[0]);
      let questionDesc = this.questionService.getQuestions().filter(q => q.id === questionId)[0];
      let questionInput = values[group]["q_" + questionId];
      let element: HTMLInputElement = <HTMLInputElement>document.getElementById(questionId + "");
      if (element) {
        let elementClasses = (<HTMLInputElement>document.getElementById(questionId + "")).classList;
        if (questionDesc.type === 'checkbox') {
          let validQuestion = (questionDesc.renderResponse().filter(r => r.selected).length >= 1);
          valid = valid && validQuestion;
          if (validQuestion) {
            elementClasses.remove("error")
          } else {
            elementClasses.add("error")
          }
        }
        if (questionDesc.type === 'checkbox-free' || questionDesc.type === 'radio-free') {
          let rndResp = questionDesc.renderResponse();
          let validQuestion = (rndResp.filter(r => r.selected).length >= 1);
          let lastRsp = rndResp[rndResp.length - 1];
          validQuestion = validQuestion && !(lastRsp.selected && lastRsp.freeMessage.trim() === '');
          valid = valid && validQuestion;
          if (validQuestion) {
            elementClasses.remove("error")
          } else {
            elementClasses.add("error")
          }
        }
        if (questionDesc.type === 'order') {
          let rndResp = questionDesc.renderResponse();
          let validQuestion = JSON.stringify(questionDesc.renderResponse().map(r => r.score).sort()) === JSON.stringify([...Array(rndResp.length + 1).keys()]
            .slice(1));
          valid = valid && validQuestion;
          if (validQuestion) {
            elementClasses.remove("error")
          } else {
            elementClasses.add("error")
          }
        }
        if (questionDesc.type === 'radio' || questionDesc.type === 'radio-inline') {
          let validQuestion = (questionDesc.renderResponse().filter(r => r.selected).length === 1);
          valid = valid && validQuestion;
          if (validQuestion) {
            elementClasses.remove("error")
          } else {
            elementClasses.add("error")
          }
        }
        if (questionDesc.type === 'free-number-warning' || questionDesc.type === 'free-number-warning-reset' || questionDesc.type === 'free-number') {
          let responses = questionDesc.renderResponse();
          let validQuestion = parseInt(responses?.filter(r => r.id)?.[0]?.freeMessage) >= 0;
          valid = valid && validQuestion;
          if (validQuestion) {
            elementClasses.remove("error")
          } else {
            elementClasses.add("error")
          }
        }
        if (questionDesc.type === 'free-number-label') {
          let responses = questionDesc.renderResponse();
          let validQuestion = (responses.filter(r => r.score).length === responses.length);
          valid = valid && validQuestion;
          if (validQuestion) {
            elementClasses.remove("error")
          } else {
            elementClasses.add("error")
          }
        }
        if (questionDesc.type === 'dropdown') {
          let responses = questionDesc.responses;
          let validQuestion = (responses.filter(r => r.selected).length === 1);
          valid = valid && validQuestion;
          if (validQuestion) {
            elementClasses.remove("error")
          } else {
            elementClasses.add("error")
          }
        }
      }
    });

    // console.log("VALUES: ", values);
    return valid;
  }

  padSingleOrderQuestionType() {
    for (let i = 0; i < this.questions.length; i++) {
      let question = this.questions[i];
      if (question.type === 'order') {
        let renderedResponses = question.renderResponse();
        if (renderedResponses.length === 1) {
          renderedResponses[0].score = 1;
        }
      }
    }
  }

  sendResults(form: FormGroup) {

    if (!this.validateForm(form)) {
      return;
    }

    this.hasAlreadyBeenClicked = true;
    this.padSingleOrderQuestionType();
    // console.log("doar o data")

    let qArray = [];
    for (let i = 0; i < this.questions.length; i++) {
      let question = this.questions[i];
      if (question.type !== 'order' && (!question.render || !question.render())) {
        continue;
      }

      for (let j = 0; j < question.responses.length; j++) {
        let response = question.responses[j];


        let record = {
          'surveyId': this.surveyId,
          'idQuestion': question.id,
          'type': question.type,
          "idResponse": response.id,
          "selected": response.selected,
          "score": response.score,
          "freeMessage": response.freeMessage,
          "questionText": question.text,
          "responseText": response.text,
          "layout": question.layout,
          "flavour": response.flavour,
          "brand": response.brand,
          "category": response.category,






        };
        if (record.selected || record.score > 0 || record.freeMessage !== '' || (this.questions[this.questions.length - 1]?.id == question?.id && record.freeMessage == '' && question.type == 'free-message')) {
          if (question.type === 'checkbox-free' && !record.selected) {
            continue;
          } else {
            qArray.push(record);
          }
        }
      }
    }

    this.surveyService.postSurvey(this.surveyId, qArray)
      .subscribe({
        next: (data: any) => {
          if (data.error === true) {
            console.error(data.message);
            alert('A aparut o eroare! Va rugam reveniti!')
          } else {
            this.router.navigateByUrl('/outro')
          }
        },
        error: (error: any) => {
          console.error(error.message);
          alert('A aparut o eroare! Va rugam reveniti!')
        }
      })

  }



  renderQuestions() {
    // console.log(this.questions)
    return this.questions.filter(q => q.render());
  }
}
